export class Stopwatch {
    static start(timerId) {
        if (typeof this.timers[timerId] === "undefined") {
            this.timers[timerId] = performance.now();
        }
    }
    static getElapsedTime(timerId) {
        return typeof this.timers[timerId] === "undefined"
            ? "StopwatchNotStarted"
            : performance.now() - this.timers[timerId];
    }
    static reset(timerId) {
        delete this.timers[timerId];
    }
    static isRunning(timerId) {
        return typeof this.timers[timerId] !== "undefined";
    }
}
Stopwatch.timers = {};
//# sourceMappingURL=Stopwatch.js.map